import type { ComponentSchema } from '../../../../../schema-types'
import { CONTENT_PAGES, headingFields, SECTION_STYLE_FIELDS } from './_fields'

/**
 * Review cards. Reviews the merchant enters are shown as written; featured reviews from the store's own
 * review data replace them once the backend offers them. Hidden when there are none.
 */
export const schema: ComponentSchema = {
  type: 'reviews',
  label: 'Customer reviews',
  description: 'A swipe row of review cards: rating, quote, name and the product.',
  supportedPages: CONTENT_PAGES,
  variants: [{ id: 'v1', label: 'Review cards' }],
  commonFields: [
    ...headingFields({ eyebrow: 'Reviews', title: 'What customers say' }),
    {
      key: 'items',
      label: 'Reviews',
      type: 'array',
      help: 'Real reviews from your customers, with their permission.',
      itemSchema: [
        { key: 'rating', label: 'Rating (1–5)', type: 'number', default: 5 },
        { key: 'title', label: 'Title', type: 'localized-string' },
        { key: 'body', label: 'Review', type: 'localized-text' },
        { key: 'name', label: 'Customer name', type: 'string' },
        { key: 'productId', label: 'Product', type: 'product-select' },
      ],
      default: [],
    },
    { key: 'limit', label: 'Most reviews shown', type: 'number', default: 6 },
    { key: 'minRating', label: 'Lowest rating shown (store reviews)', type: 'number', default: 4 },
    ...SECTION_STYLE_FIELDS,
  ],
}
